import FlowLine from "ol-ext/style/FlowLine";
import { scaleLog } from "d3-scale";
import { lengthOnPlaneCm } from "@orbis-lr-sdk/orbis-lr-sdk";
import { featureTo4326Geometry } from "../../util";
import { maxSpeedFromCurvature } from "./curvature";
import { createLinearInterpolator } from "./util/linearInterpolation";
import { speedToT } from "./util/colorScale";
export { lrDecode, lrDecodeRelation } from "./util/lrDecoding";
import { lrDecode } from "./util/lrDecoding";

export function getLengthCm(feature) {
  const geometry = featureTo4326Geometry(feature);
  const lengthCm = lengthOnPlaneCm(geometry);
  return lengthCm;
}

export function getLinearTagFlowStyle(
  linearTag,
  width,
  feature,
  colorInterpolator,
  linearKey = "curvature",
  zIndex = undefined,
) {
  const lengthCm = getLengthCm(feature);
  const lrChain = lrDecode("bla:linear", linearTag);

  const dataPoints = lrChain.elements.map((element) => ({
    distance: element.getStartDistance() / lengthCm,
    value: parseInt(element.getValue()),
  }));
  const interpolate = createLinearInterpolator(dataPoints);
  const offsetToLinearTag = function wrapper(offset) {
    if (lengthCm === 0) {
      return 0;
    } else {
      return interpolate(offset);
    }
  };

  var normalizeLinearTagPositive;
  if (linearKey === "laneWidth") {
    normalizeLinearTagPositive = scaleLog([230, 450], [1, 0]);
  } else if (linearKey === "curvature") {
    // Convert curvature to a lateral-acceleration-derived speed, then map to
    // the shared FCD spectrum t so high speed (gentle curve) → 1 (red) and
    // low speed (sharp curve) → 0 (violet).
    normalizeLinearTagPositive = (curvature) =>
      speedToT(maxSpeedFromCurvature(curvature));
  } else {
    normalizeLinearTagPositive = scaleLog([1, 350], [0, 1]);
  }

  const normalizeLinearTag = function (linearTag) {
    if (linearKey !== "curvature" && linearTag < 1 && linearTag > -1) {
      return 0;
    }
    if (linearTag > 0) {
      return normalizeLinearTagPositive(linearTag);
    }
    return normalizeLinearTagPositive(-linearTag);
  };

  const flowStyle = new FlowLine({
    zIndex: zIndex,
    color: function (f, step) {
      const linearTag = offsetToLinearTag(step);

      if (isNaN(linearTag)) {
        return "rgb(128, 128, 128)";
      }

      const linearTagNormalized = normalizeLinearTag(linearTag);
      const color = colorInterpolator(linearTagNormalized);
      if (color === "rgb(0, 0, 0)") {
        return "rgb(255, 255, 255)";
      }
      return color;
    },
    width: width,
    visible: false,
  });

  return flowStyle;
}
